import { User, UserMin } from '@apiContract';

import { useSettings } from './useSettings';
import { useUserLocation } from './useUserLocation';
import { getRoutesList } from 'src/utils/mappers';
import { useRoutesByLocation } from './useRoutesByLocation';

type Settings = {
  AssignmentCardShowUserId: boolean;
  AssignmentCardShowAutoAssignId: boolean;
  AssignmentCardShowRoutes: boolean;
  AssignmentCardShowLocation: boolean;
};

const getStringValue = (str?: any) => str ? str : '';

const getString = (value1: any, value2: any) => {
  return `${getStringValue(value1)}${getStringValue(value1 && value2 && ' • ')}${getStringValue(value2)}`
}

export const useUserInfoLines = (user?: User | UserMin | null) => {
  const settings = useSettings([
    'AssignmentCardShowUserId',
    'AssignmentCardShowAutoAssignId',
    'AssignmentCardShowRoutes',
    'AssignmentCardShowLocation',
  ]) as Settings;

  const { location, isLoading: isLocationResponseLoading } = useUserLocation(user);
  const { isLoading: isRoutesLoading, data: routes } = useRoutesByLocation(location?.id);

  const userID = settings.AssignmentCardShowUserId && user?.userName;
  const userAutoassignId = settings.AssignmentCardShowAutoAssignId && user?.autoAssignId;
  const userLocation = settings.AssignmentCardShowLocation && location?.name;
  const userRoute = settings.AssignmentCardShowRoutes && getRoutesList(routes);

  return {
    idLine: getString(userID, userAutoassignId),  
    routesLine: getString(userRoute, userLocation),         
    isRoutesLoading: isLocationResponseLoading || isRoutesLoading,
  }
};